// Должен соответствовать projectName
/* istanbul ignore next */
export const UNIQUE_CONFIG_KEY = 'frontend-content';

/** Значение параметра limit для листингов по умолчанию */
export const LISTING_REQUEST_LIMIT = 18;

/** Значение параметра limit для апи-ручки fetchGetNewsMain */
export const MAIN_NEWS_REQUEST_LIMIT = 10;

/** Значение параметра limit для апи-ручки fetchGetArticleMain */
export const MAIN_ARTICLES_REQUEST_LIMIT = LISTING_REQUEST_LIMIT;

/** Значение параметра limit для апи-ручки fetchGetArticleList */
export const ARTICLE_LIST_REQUEST_LIMIT = LISTING_REQUEST_LIMIT;

/** Значение параметра limit для апи-ручки fetchGetNewsList */
export const NEWS_LIST_REQUEST_LIMIT = LISTING_REQUEST_LIMIT;

/** Значение параметра limit для апи-ручки fetchGetNewsList */
export const BLOG_LIST_REQUEST_LIMIT = LISTING_REQUEST_LIMIT;

/** Урл Циана */
export const CIAN_URL = '//www.cian.ru';
